import type { Patient as PatientV1 } from '@pbt/pbt-ui-components'

import { useUpdatePatientsBatchMutation } from '~/api/graphql/generated/types'

export const useUpdatePatientsBatch = (
  businessId: string,
  clientId: string,
) => {
  const [updatePatientsBatch, { loading, error, reset }] =
    useUpdatePatientsBatchMutation()

  return {
    updatePatientsBatchLoading: loading,
    updatePatientsBatchError: error,
    resetUpdatePatientsBatch: reset,
    updatePatientsBatch: (patients: PatientV1[]) => {
      if (!businessId || !clientId) {
        return
      }

      updatePatientsBatch({
        variables: {
          businessId,
          clientId,
          input: patients.map((patient) => ({
            id: patient.id,
            sendReminders: patient.sendReminders,
          })),
        },
      })
    },
  }
}
